import { graphql } from 'react-relay';

export const surveyAddressQuery = graphql`
  query addressQuery {
    getSurveyAddress {
      #시/도
      sidoNm
    }
  }
`;

export const surveyAddress1 = graphql`
  query addressSggQuery($sidoNm: String) {
    getSurveyAddress(sidoNm: $sidoNm) {
      #시/군/구
      sggNm
    }
  }
`;
export const surveyAddress2 = graphql`
  query addressYmdgQuery($sidoNm: String, $sggNm: String) {
    getSurveyAddress(sidoNm: $sidoNm, sggNm: $sggNm) {
      #읍/면/동
      ymdgNm
    }
  }
`;
